import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const adminApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('dotcall_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      localStorage.removeItem('dotcall_admin_token');
      localStorage.removeItem('dotcall_admin');
      window.location.href = '/admin';
    }
    return Promise.reject(err);
  }
);

export const adminAuthAPI = {
  login: (data) => adminApi.post('/admin/login', data),
  me: () => adminApi.get('/admin/me'),
  changePassword: (data) => adminApi.put('/admin/change-password', data),
};

export const adminUsersAPI = {
  list: () => adminApi.get('/admin/users'),
  get: (id) => adminApi.get(`/admin/users/${id}`),
  update: (id, data) => adminApi.put(`/admin/users/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/users/${id}`),
  create: (data) => adminApi.post('/admin/users/create', data),
  manageWallet: (id, data) => adminApi.post(`/admin/users/${id}/wallet`, data),
};

export const adminStatsAPI = {
  get: () => adminApi.get('/admin/stats'),
};

export const adminConfigAPI = {
  list: () => adminApi.get('/admin/config'),
  get: (key) => adminApi.get(`/admin/config/${key}`),
  set: (key, value) => adminApi.put('/admin/config', { key, value }),
  delete: (key) => adminApi.delete(`/admin/config/${key}`),
};

export const adminSmtpAPI = {
  sendTest: () => adminApi.post('/admin/send-test-email'),
};

export const adminSeoAPI = {
  get: () => adminApi.get('/seo-settings'),
  update: (data) => adminApi.put('/admin/seo-settings', data),
};

export const adminDemoCallsAPI = {
  getCalls: () => adminApi.get('/admin/demo-calls'),
  getWhitelist: () => adminApi.get('/admin/demo-whitelist'),
  addWhitelist: (data) => adminApi.post('/admin/demo-whitelist', data),
  removeWhitelist: (phone) => adminApi.delete(`/admin/demo-whitelist/${encodeURIComponent(phone)}`),
};

export const adminInvestorsAPI = {
  list: () => adminApi.get('/admin/investors'),
  create: (data) => adminApi.post('/admin/investors', data),
  update: (id, data) => adminApi.put(`/admin/investors/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/investors/${id}`),
};

export const adminExpensesAPI = {
  list: (month) => adminApi.get('/admin/expenses', { params: month ? { month } : {} }),
  create: (data) => adminApi.post('/admin/expenses', data),
  update: (id, data) => adminApi.put(`/admin/expenses/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/expenses/${id}`),
};

export const adminInvestorSettingsAPI = {
  get: () => adminApi.get('/admin/investor-settings'),
  update: (data) => adminApi.put('/admin/investor-settings', data),
};

export const adminInvestorDashboardAPI = {
  get: (month) => adminApi.get('/admin/investor-dashboard', { params: month ? { month } : {} }),
};

export const adminShowcasesAPI = {
  list: () => adminApi.get('/admin/demo-showcases'),
  create: (data) => adminApi.post('/admin/demo-showcases', data),
  update: (id, data) => adminApi.put(`/admin/demo-showcases/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/demo-showcases/${id}`),
};

export const adminBlogAPI = {
  list: (params = {}) => adminApi.get('/admin/blog/posts', { params }),
  create: (data) => adminApi.post('/admin/blog/posts', data),
  update: (id, data) => adminApi.put(`/admin/blog/posts/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/blog/posts/${id}`),
  getAISettings: () => adminApi.get('/admin/blog/ai-settings'),
  updateAISettings: (data) => adminApi.put('/admin/blog/ai-settings', data),
  generateNow: (topic) => adminApi.post('/admin/blog/generate-now', topic ? { topic } : {}),
  regenerateImage: (id, prompt) => adminApi.post(`/admin/blog/posts/${id}/regenerate-image`, prompt ? { prompt } : {}),
};

export const adminSeoTasksAPI = {
  list: () => adminApi.get('/admin/seo/tasks'),
  create: (data) => adminApi.post('/admin/seo/tasks', data),
  update: (id, data) => adminApi.put(`/admin/seo/tasks/${id}`, data),
  delete: (id) => adminApi.delete(`/admin/seo/tasks/${id}`),
  health: () => adminApi.get('/admin/seo/health'),
};


export default adminApi;
